export default __webpack_public_path__ + "static/media/blog4.0cdaa303.png";